import { useFormik } from "formik";
import React from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import api from "../../api/auth_api";
import { SVG } from "../../assets/SVG/SVG";
import * as slides from "../../component/Carousel/CarousalSlides";
import Carousel from "../../component/Carousel/Carousel";
import { Button, CustomInput } from "../../component/common";

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .email("Email not valid"),
    }),
    validateOnBlur: true,
    onSubmit: async (values) => {
      const data = { email: values.email };
      const res = await api.forgotPassword(data);
      if (res.data.success === true) {
        navigate("/forgotpass_success", { replace: true });
      }
    },
  });

  return (
    <div className="flex justify-center items-center max-h-screen">
      <div className="flex justify-center items-center h-screen lg:w-1/2">
        <div className="w-3/6 flex flex-col gap-2" >
          <SVG.LogoDark />
          <p className="text-xl mt-4 font-semibold" >{"Forgot Password"}</p>
          <form onSubmit={formik.handleSubmit}>
            <div className="flex flex-col gap-4">
              <CustomInput
                label="Business Email"
                name="email"
                type="text"
                placeholder="Email"
                value={formik.values.email}
                isError={!!formik.touched.email && !!formik.errors.email}
                onChange={formik.handleChange}
                errorMessage={formik.errors.email}
              />
              <Button type="submit" className="w-full" text={"Submit"} />
            </div>
          </form>
          <div className="mt-2">
            <span className="text-input-label">Back to</span>
            <span
              onClick={() => navigate("/signin")}
              className="hover:underline text-button-primary pl-2"
            >
              Sign In
            </span>
          </div>
        </div>
      </div>
      <div className="w-1/2 h-screen hidden lg:flex lg:justify-center lg:items-center">
        <div className="onboard-box">
          <Carousel slides={slides.slides} />
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
